import { useMediaQuery } from '@mantine/hooks'
import { useMantineTheme } from '@mantine/core'

export const useIsMobileNav = (): boolean => {
  const theme = useMantineTheme()
  return useMediaQuery(`(max-width: calc(${theme.breakpoints.sm} - 0.1px))`, false, {
    getInitialValueInEffect: false,
  })
}
